export default __webpack_public_path__ + "static/media/Roboto-MediumItalic.a186f4b1.ttf";